console.log('[GLOBAL]', 'JS file loaded');

// Custom Js for how to use page
const howToUseNavbar = document.querySelector(".section-how-to-use-navbar");
if (howToUseNavbar) {
    (function () {
        const navbar = document.querySelector('.section-how-to-use-navbar');

        if (navbar && navbar.parentElement) {
        navbar.parentElement.classList.add('how-to-use-navbar-container');
        }
    })();

    (function () {
    'use strict';

    function formatToClass(str) {
        return str
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function getHeaderOffset() {
        const header = document.querySelector('.header, .site-header, .sticky-header');
        return header ? header.offsetHeight : 0;
    }

    function scrollWithOffset(el) {
        const offset = getHeaderOffset() + 60;
        const top = el.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
        top,
        behavior: 'smooth'
        });
    }

    const navLinks = document.querySelectorAll('.section-how-to-use-navbar a');

    if (navLinks.length) {
        navLinks[0].classList.add('active');
    }

    navLinks.forEach(link => {
        link.addEventListener('click', function (e) {
        e.preventDefault();

        const targetClass = 'section-' + formatToClass(this.textContent);
        console.log(targetClass);

        const targetEl = document.querySelector(`.howtouse-product-item.${targetClass}`);
        if (!targetEl) return;

        scrollWithOffset(targetEl);

        navLinks.forEach(l => l.classList.remove('active'));
        this.classList.add('active');
        });
    });
    })();
}


// custom code slider
// function smoothSlider(slider, duration = 2500) {
//   const originalScrollTo = slider.scrollTo.bind(slider);

//   slider.scrollTo = function (options) {
//     const start = slider.scrollLeft;
//     const end =
//       typeof options === 'object' ? options.left : arguments[0];

//     const startTime = performance.now();

//     function animate(time) {
//       const elapsed = time - startTime;
//       const progress = Math.min(elapsed / duration, 1);

//       // smooth easing
//       const ease = 1 - Math.pow(1 - progress, 3);

//       slider.scrollLeft = start + (end - start) * ease;

//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       }
//     }

//     requestAnimationFrame(animate);
//   };

//   return originalScrollTo;
// }

// usage
//smoothSlider(document.querySelector('.lp-top-billboard slideshow-slides'), 2500);

// Fix for alternate product images displaying incorrectly on iOS
document.addEventListener('DOMContentLoaded', function () {

        if (window.innerWidth >= 750) return;
        var sliders = document.querySelectorAll('.section-resource-list .resource-list__slide');

        sliders.forEach(function (slider) {
            var slides = slider.querySelectorAll('slideshow-slides slideshow-slide');

            slides.forEach(function (slide, i) {
            if (i === 0) return; // keep first one
            slide.remove();      // remove all others
            });
        });
});

// T&C scroll Navigation
document.querySelectorAll('.scroll-link').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    const target = document.querySelector(targetId);
    const header = document.querySelector('header'); // change to your header selector

    if (target) {
      const headerHeight = header ? header.offsetHeight : 0;
      const offset = headerHeight + 20; // 20px breathing room

      const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;
      const startTop = window.scrollY;
      const distance = targetTop - startTop;
      const duration = 1000;
      let startTime = null;

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function animateScroll(currentTime) {
        if (!startTime) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        window.scrollTo(0, startTop + distance * easeInOutCubic(progress));

        if (progress < 1) requestAnimationFrame(animateScroll);
      }

      requestAnimationFrame(animateScroll);
    }
  });
});

if (document.body.classList.contains('template-collection')) {
  document.querySelectorAll('.collection-product-group__title').forEach(el => {
    el.setAttribute(
      'data-collection-name',
      el.textContent.trim().toLowerCase().replace(/\s+/g, '-')
    );
  });
}

// (function () {
//     function bindPrivacyLink() {
//         document.querySelectorAll('footer li a').forEach(link => {
//             const text = link.textContent
//                 .replace(/\u200B/g, '')
//                 .replace(/\s+/g, ' ')
//                 .trim();

//             if (text === 'YOUR PRIVACY CHOICES' && !link.dataset.bound) {
//                 link.dataset.bound = 'true';

//                 // Remove default navigation
//                 link.removeAttribute('href');

//                 // Optional: show pointer cursor
//                 link.style.cursor = 'pointer';

//                 link.addEventListener('click', function (e) {
//                     e.preventDefault();
//                     e.stopPropagation();

//                     //if (window.UC_UI) {
//                         window.UC_UI.showSecondLayer();
//                     //}
//                 });
//             }
//         });
//     }

//     // Initial bind
//     bindPrivacyLink();

//     // Re-bind if footer is rendered dynamically
//     new MutationObserver(bindPrivacyLink).observe(document.body, {
//         childList: true,
//         subtree: true
//     });
// })();


(function () {
    function setupPrivacyLink() {
        document.querySelectorAll('footer li a').forEach(link => {
            const text = link.textContent
                .replace(/\u200B/g, '')
                .replace(/\s+/g, ' ')
                .trim();

            if (text === 'YOUR PRIVACY CHOICES' && !link.dataset.bound) {
                link.dataset.bound = 'true';

                link.removeAttribute('href');

                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    console.log('Privacy link clicked');

                    setTimeout(function () {
                        if (window.UC_UI && window.UC_UI.showSecondLayer) {
                            console.log('Opening Usercentrics');
                            window.UC_UI.showSecondLayer();
                        }
                    }, 100);
                });
            }
        });
    }

    setupPrivacyLink();

    new MutationObserver(setupPrivacyLink).observe(document.body, {
        childList: true,
        subtree: true
    });
})();

function updateAnnouncementBarAccessibility() {
  const slides = document.querySelectorAll(
    'announcement-bar-component .announcement-bar__slide'
  );

  slides.forEach((slide) => {
    const isHidden = slide.getAttribute('aria-hidden') === 'true';

    if (isHidden) {
      slide.setAttribute('inert', '');
    } else {
      slide.removeAttribute('inert');
    }
  });
}

function initAnnouncementBarAccessibility() {
  updateAnnouncementBarAccessibility();

  const announcementBar = document.querySelector(
    'announcement-bar-component'
  );

  if (!announcementBar) return;

  const observer = new MutationObserver(() => {
    updateAnnouncementBarAccessibility();
  });

  observer.observe(announcementBar, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    subtree: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initAnnouncementBarAccessibility
  );
} else {
  initAnnouncementBarAccessibility();
}